import { Component, Host, Prop, getAssetPath, h } from '@stencil/core';

@Component({
  tag: 'sportsline-free-expert-pick-header',
  styleUrl: 'sportsline-free-expert-pick-header.css',
  shadow: true,
})
export class SportslineFreeExpertPickTitleAndExpert {
  /**
   * The title to be displayed in the card.
   */
  @Prop() cardTitle: string;

  render() {
    return (
      <Host>
        <div class="sportsline-free-expert-pick-header">
          <div class="sportsline-free-expert-pick-header-bar"></div>
          <div class="sportsline-free-expert-pick-header-wrapper">
            <div class="sportsline-free-expert-pick-header-icon">
              <img height={34} src={getAssetPath('./assets/images/pick-of-the-day.svg')} />
            </div>
            <div class="sportsline-free-expert-pick-header-title">
              <h1>{this.cardTitle}</h1>
            </div>
          </div>
          <slot />
        </div>
      </Host>
    );
  }
}
